import React from "react";
import { t } from "ttag";

import { LoadingSpinner } from "../../../components/LoadingSpinner";
import { IMattressMatchResult } from "../../../models/catalogue";
import { useAppSelector } from "../../../store/reducers";
import { Result } from "../Result";
import { FetchResultsStatusType } from "../constants";
import { mostSimilarProducts } from "../selectors";

import styles from "./index.module.scss";

export const MattressMatchResults = (): React.JSX.Element => {
    const mattressMatches = useAppSelector((state) =>
        mostSimilarProducts(state.mattressmatch),
    );
    const fetchResultsStatus = useAppSelector(
        (state) => state.mattressmatch.ui.fetchResultsStatus,
    );
    if (fetchResultsStatus === FetchResultsStatusType.ERROR) {
        return (
            <div className={styles.loading}>
                <h3>{t`No results found for your criteria.`}</h3>
            </div>
        );
    }
    if (
        !mattressMatches ||
        fetchResultsStatus === FetchResultsStatusType.LOADING
    ) {
        return (
            <div className={styles.loading}>
                <LoadingSpinner />
            </div>
        );
    }
    return (
        <>
            <div className={styles.results}>
                {mattressMatches.map(
                    (mattressMatchResult: IMattressMatchResult, idx) => {
                        return (
                            <Result
                                key={idx}
                                product={mattressMatchResult.product}
                                productImg={mattressMatchResult.image_url}
                                productCopy={mattressMatchResult.copy}
                                feel={mattressMatchResult.feel}
                                isBestMatch={idx === 0}
                            />
                        );
                    },
                )}
            </div>
        </>
    );
};
